<template>
    <div v-if="!selectedFile">
        <v-col>
            <v-btn color="primary" outlined class="ml-1 pa-5" dark :loading="isSelecting" @click="handleFileImport">
                <v-icon class="mr-2">{{ icono }}</v-icon>
                {{ titulo }}
            </v-btn>
            <!-- Create a File Input that will be hidden but triggered with JavaScript -->
            <!-- Ver formatos en accept -->
            <input ref="uploader" class="d-none" type="file" accept="image/*" @change="onFileChanged">
        </v-col>
    </div>
    <div v-else>
        <v-row>
            <v-col class="d-flex py-4 justify-center align-center">
                <v-avatar size="230" class="elevation-2" :tile="(this.tipo !== 'fotoperfil')">
                    <canvas id="canvas" width="300" height="230" ref="cv"></canvas>
                </v-avatar>
            </v-col>
        </v-row>
        <v-col class="d-flex justify-center">
            <v-btn @click="descartar" color="primary" elevation="0" class="mr-1 pa-5" dark>
                <v-icon class="mr-2">mdi-delete-outline</v-icon>
                DESCARTAR
            </v-btn>
            <v-btn @click="enviarFoto" text color="primary" class="ml-1 pa-5" dark>
                <v-icon class="mr-2">mdi-check</v-icon>
                ACEPTAR
            </v-btn>
        </v-col>
    </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'InputButton',
    data() {
        return {
            isSelecting: false,
            selectedFile: null,
            visible: true,
            subida: false
        }
    },
    methods:
    {
        ...mapActions('dataUser', ['precargaFoto', 'subirFotoCarnet', 'subirFotoPerfil']),
        ...mapActions('preafiliacion', ['addFotoCarnet']),
        ...mapActions('auth', ['validarImagen']),

        enviarFoto() {
            console.log(this.tipo)
            if (this.tipo == 'fotoperfil') {
                this.subirFotoPerfil({ nroafi: this.nroafi, fotoperfil: this.fototmp })
                this.$emit('fotoCargada')
            } else if (this.tipo == 'fotocarnet') {
                this.subirFotoCarnet({ nroafi: this.nroafi, fotocarnet: this.fototmp })

            } else {

            }
            /* 
            else if (this.tipo == 'fotoperfil')
                this.subirFotoCarnet()
        } else {
            this.addFotoCarnet(arr[1])
        }
                        this.subida = true 
                                    this.precargaFoto(arr[1])
                        * /
                    this.subirFotoCarnet() */
        },
        descartar() {
            if (this.isAuthenticated) {
                this.precargaFoto('')
            } else {
                this.addFotoCarnet('')
            }
            this.selectedFile = null
            this.subida = false
        },
        handleFileImport() {
            this.isSelecting = true;

            // After obtaining the focus when closing the FilePicker, return the button state to normal
            window.addEventListener('focus', () => {
                this.isSelecting = false
            }, { once: true });

            // Trigger click on the FileInput
            try {
                this.$refs.uploader.click();
            } catch (error) {

            }
        },
        onFileChanged(e) {
            //validar si la imagen es oscura
            const formData = new FormData()
            FormData.append('file', e.target.files[0])
            FormData.append('threshold', 0.7)
            this.validarImagen(formData)
            if (e.target.files[0]) {
                this.selectedFile = e.target.files[0]
                // incluyo consulta de validar imagen
                //this.precargaFoto(this.selectedFile)

                //envio señal de fotoSeleccionada
                //this.$emit('haySeleccion')
                const reader = new FileReader();
                reader.onloadend = () => {
                    //referencia al elemento canvas
                    let canvas = this.$refs.cv
                    //config
                    const ctx = canvas.getContext('2d');

                    //nueva imagen
                    const img = new Image

                    img.src = URL.createObjectURL(this.selectedFile)
                    img.onload = function () {
                        console.log(canvas.width)
                        console.log(canvas.height)
                        console.log(img.naturalWidth)
                        console.log(img.naturalHeight)
                        var hRatio = canvas.width / img.naturalWidth
                        var vRatio = canvas.height / img.naturalHeight
                        var ratio = Math.min(hRatio, vRatio)

                        var centerX = (canvas.width - img.width * ratio) / 2
                        var centerY = (canvas.height - img.height * ratio) / 2

                        // ctx.clearRect(0, 0, canvas.width, canvas.height)

                        //ctx.drawImage(img, 0, 0, img.width, img.height, centerX, centerY, img.width * ratio, img.height * ratio);
                        ctx.drawImage(img, 0, 0, img.width, img.height, centerX, centerY, img.width * ratio, img.height * ratio);

                    }
                    let dataURL = canvas.toDataURL('img/png');
                    const arr = dataURL.split(',');

                    //seguir aca, subir donde corresponda la fototmp
                    if (isAuthenticated) {
                        this.precargaFoto(arr[1])
                    } else {
                        //revisar
                        this.addFotoCarnet(arr[1])

                    }

                };
                reader.readAsDataURL(this.selectedFile)
            }
        },
    },
    computed: {
        ...mapGetters('auth', ['nroafi', 'isAuthenticated']),
        ...mapGetters('dataUser', ['fototmp']),
        // ...mapGetters('preafiliacion', ['fototmp']),
    },
    props: ['titulo', 'icono', 'tipo']
}
</script>